function getApplicationConfig() {
  var nodeEnv = process.env.NODE_ENV;

  if (!nodeEnv) {
    throw new Error(
      'NODE_ENV environment variable is not set. Please set NODE_ENV to development, staging, or production.'
    );
  }

  window.nodeEnv = nodeEnv;
  const serverConfig = require(`@/core/config/applicationConfig/exports-${nodeEnv}.json`);
  return {
    ...require(`@/core/config/applicationConfig/${nodeEnv}.json`),
    server: serverConfig
  };
}

export { getApplicationConfig };
